import { useTranslation } from "react-i18next";
import "./style.scss";
import { useSocketContext } from "../../Socket";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useStopwatch } from "react-timer-hook";

export const ConnectionAlert = () => {
  const [show, setShow] = useState(false);
  const { connected } = useSocketContext();
  const { t } = useTranslation();
  const { userInfo } = useSelector((state: any) => state.setReducer);

  // don't hide alert if it's disconnected more than 3 seconds
  let { reset, pause, totalSeconds, start } = useStopwatch();

  const MAX_DISCONNECT_TIME = 3;

  useEffect(() => {
    // don't render this component at first
    let timer = setTimeout(() => {
      setShow(true);
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (connected || !show || !userInfo) {
      pause();
    } else if (totalSeconds < MAX_DISCONNECT_TIME) {
      reset();
    } else {
      start();
    }
  }, [connected, show, userInfo]);

  if (totalSeconds < MAX_DISCONNECT_TIME && (connected || !show || !userInfo))
    return null;

  return (
    <div className="connection-alert">
      <div className="alert">
        {t("general.connection_alert", { seconds: totalSeconds })}
        <p>{totalSeconds} seconds</p>
        <span onClick={() => window.location.reload()}>Refresh Now</span>
      </div>
    </div>
  );
};
